/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

export const GET_ORDER_DETAILS = gql`
  query GetOrderDetails($code: String!) {
    orderByCode(code: $code) {
      updatedAt
      ...Cart
      shippingAddress {
        ...OrderAddress
      }
      subOrders {
        id
        state
        lines {
          id
          productVariant {
            id
            name
            featuredAsset {
              source
              preview
            }
          }
          featuredAsset {
            source
            preview
          }
          linePriceWithTax
          deliveryDate
          quantity
          cancelledQuantity
        }
        deliveryTime
      }
    }
  }
  fragment Cart on Order {
    id
    code
    state
    active
    customer {
      firstName
      lastName
      phoneNumber
    }
    timeWindow {
      description
    }
    deliveryTime
    subTotal
    subTotalWithTax
    total
    totalWithTax
    shipping
    shippingWithTax
  }
  fragment OrderAddress on OrderAddress {
    fullName
    company
    streetLine1
    streetLine2
    city
    province
    postalCode
    country
    phoneNumber
    __typename
  }
`;
